import portfolio_img from './assets/portfolio_img.png';
import tank_img from './assets/tank_img.png';
import retail_img from './assets/retail_img.png';

import c from './assets/skillbubbles/c.png';
import cpp from './assets/skillbubbles/cpp.png';
import java from './assets/skillbubbles/java.png';
import python from './assets/skillbubbles/python.png';
import html from './assets/skillbubbles/html.png';
import css from './assets/skillbubbles/css.png';
import js from './assets/skillbubbles/js.png';
import mongodb from './assets/skillbubbles/mongodb.png';
import express from './assets/skillbubbles/express.png';
import react from './assets/skillbubbles/react.png';
import node from './assets/skillbubbles/node.png';
import mysql from './assets/skillbubbles/mysql.png';
import threejs from './assets/skillbubbles/threejs.png';
import figma from './assets/skillbubbles/figma.png';
import blender from './assets/skillbubbles/blender.png';
import adobe from './assets/skillbubbles/adobe.png';
import git from './assets/skillbubbles/git.png';
import github from "./assets/github_icon.svg";

const navlinks = ["Home", "Projects", "Skills", "Contact"];

const portfolio = {
    title: "Portfolio",
    description: "Portfolio website created using React.js, Bootstrap and Three.js",
    link: "https://github.com/aryanGupta-09/React_Portfolio",
    image: portfolio_img
}
const tankstars = {
    title: "TankFight",
    description: "A tank fighting game created using Java, LibGDX and Box2D",
    link: "https://github.com/aryanGupta-09/TankStarsGame",
    image: tank_img
}
const nexusmart = {
    title: "NexusMart",
    description: "An online retail store created using HTML, CSS, JavaScript, MySQL, SCSS, Bootstrap",
    link: "https://github.com/aryanGupta-09/DBMS_OnlineRetailStore",
    image: retail_img
}
const projects = [portfolio, tankstars, nexusmart];

const skillbubbles = [c, cpp, java, python, html, css, js, mongodb, express, react, node, mysql, threejs, figma, blender, adobe, git, github];

export {navlinks, projects, skillbubbles};